import APIURL from './urls'
import AppTools from 'utils/app/appTools'
import RegionTools from 'utils/regions/regionTools'

const fetchJSON = url => fetch(url).then(response => response.json())

const getRegions = () => {
  const lang = AppTools.getActualLanguage()
  if (sessionStorage.getItem(`regions_${lang}`)) {
    return Promise.resolve(JSON.parse(sessionStorage.getItem(`regions_${lang}`)))
  } else {
    return Promise.resolve(
      fetchJSON(APIURL.getBenchmark()).then(regions => {
        sessionStorage.setItem(`regions_${lang}`, JSON.stringify(regions))
        return regions
      })
    )
  }
}

const getCountries = () => {
  const lang = AppTools.getActualLanguage()
  if (sessionStorage.getItem(`countries_${lang}`)) {
    return Promise.resolve(JSON.parse(sessionStorage.getItem(`countries_${lang}`)))
  } else {
    return Promise.resolve(
      fetchJSON(APIURL.getBenchmarkCountries()).then(countries => {
        sessionStorage.setItem(`countries_${lang}`, JSON.stringify(countries))
        return countries
      })
    )
  }
}

const getReferenceRegions = (regionsData, selectedRegionId) => {
  let selectedRegionCode = RegionTools.getRegionCodeFromId({ regionsData, id: selectedRegionId })
  return getQuery(APIURL.getReferenceRegions({ selectedRegionCode }))
}

const getIndicators = () => {
  const lang = AppTools.getActualLanguage()
  if (sessionStorage.getItem(`indicators_${lang}`)) {
    return Promise.resolve(JSON.parse(sessionStorage.getItem(`indicators_${lang}`)))
  } else {
    return Promise.resolve(
      fetchJSON(APIURL.getAllIndicators()).then(indicators => {
        sessionStorage.setItem(`indicators_${lang}`, JSON.stringify(indicators))
        return indicators
      })
    )
  }
}

const getIndicatorsStatus = () => {
  const lang = AppTools.getActualLanguage()
  if (sessionStorage.getItem(`indicatorsStatus_${lang}`)) {
    return Promise.resolve(JSON.parse(sessionStorage.getItem(`indicatorsStatus_${lang}`)))
  } else {
    return Promise.resolve(
      fetchJSON(APIURL.getIndicatorsStatus()).then(indicatorsStatus => {
        sessionStorage.setItem(`indicatorsStatus_${lang}`, JSON.stringify(indicatorsStatus))
        return indicatorsStatus
      })
    )
  }
}

const getQuery = query => {
  //if (sessionStorage.getItem(query)) {
  //  return Promise.resolve(JSON.parse(sessionStorage.getItem(query)))
  //} else {
    return Promise.resolve(
      fetchJSON(query).then(data => {
        // sessionStorage.setItem(query, JSON.stringify(data))
        return data
      })
    )
  //}
}

const api = {
  getRegions,
  getCountries,
  getReferenceRegions,
  getIndicators,
  getIndicatorsStatus,
  getQuery
}

export default api



// WEBPACK FOOTER //
// ./src/utils/api/api.js